import { SubscriptionRunInterval } from '@x/schemas/ecommerce';

export const SHOP_LANGUAGE = {
  SubscriptionRunIntervalBilling: {
    [SubscriptionRunInterval.Weekly]: $localize`:@@Interval.WEEKLY:Billed every week`,
    [SubscriptionRunInterval.Biweekly]: $localize`:@@Interval.BIWEEKLY:Billed every 2 weeks`,
    [SubscriptionRunInterval.Bimonthly]: $localize`:@@Interval.BIMONTHLY:Billed every 2 months`,
    [SubscriptionRunInterval.Monthly]: $localize`:@@Interval.MONTHLY:Billed every month`,
    [SubscriptionRunInterval.Quarterly]: $localize`:@@Interval.QUARTERLY:Billed every quarter`,
    [SubscriptionRunInterval.Yearly]: $localize`:@@Interval.YEARLY:Billed every year`,
  },

  SubscriptionRunIntervalUnit: {
    [SubscriptionRunInterval.Bimonthly]: $localize`:@@Money.Interval.BIMONTHLY:every 2 months`,
    [SubscriptionRunInterval.Biweekly]: $localize`:@@Money.Interval.BIWEEKLY:every 2 weeks`,
    [SubscriptionRunInterval.Monthly]: $localize`:@@Money.Interval.MONTHLY:/ month`,
    [SubscriptionRunInterval.Quarterly]: $localize`:@@Money.Interval.QUARTERLY:/ quarter`,
    [SubscriptionRunInterval.Weekly]: $localize`:@@Money.Interval.WEEKLY:/ week`,
    [SubscriptionRunInterval.Yearly]: $localize`:@@Money.Interval.YEARLY:/ year`,
  },
};
